import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import KapeiLogo from "@/components/KapeiLogo";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function StaffLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin" && u.role !== "staff") {
        setErr("Esta cuenta no tiene acceso al panel interno.");
        return;
      }
      toast.success("Acceso interno");
      navigate("/staff");
    } catch (e2) { setErr(e2.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <div className="mx-auto flex min-h-screen max-w-md flex-col px-6 py-16">
        <div className="mb-12 flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-[#4d7c0f] font-black">K</span>
          <span className="text-2xl font-black tracking-tight">KAPEI · Panel interno</span>
        </div>
        <div className="rounded-3xl bg-slate-800 p-8 shadow-2xl">
          <div className="mb-6 flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-[#bef264]">
            <Lock className="h-4 w-4" /> Acceso restringido
          </div>
          <form onSubmit={onSubmit} className="flex flex-col gap-4">
            <div>
              <Label className="text-xs font-bold uppercase tracking-widest text-slate-400">Email</Label>
              <Input
                data-testid="staff-email"
                type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 h-12 rounded-xl border-slate-700 bg-slate-900 px-4 text-base text-white"
              />
            </div>
            <div>
              <Label className="text-xs font-bold uppercase tracking-widest text-slate-400">Contraseña</Label>
              <Input
                data-testid="staff-password"
                type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-2 h-12 rounded-xl border-slate-700 bg-slate-900 px-4 text-base text-white"
              />
            </div>
            {err && <p data-testid="staff-error" className="text-sm font-bold text-red-400">{err}</p>}
            <Button
              data-testid="staff-submit"
              type="submit" disabled={loading}
              className="mt-2 h-12 rounded-xl bg-[#4d7c0f] text-base font-bold hover:bg-[#3f6212]"
            >
              {loading ? "Entrando…" : "Entrar al panel"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
